import firebase from 'firebase/app';
import 'firebase/analytics';
import { IS_PRODUCTION, IS_MASTER } from '@utils/constants';

// All of this is public informations and keys
export const FIREBASE_CONFIG = {
    apiKey: 'AIzaSyA3sSx8nQgSwCLs1Nj6dzJrcenaLDkSZ2o',
    authDomain: 'kiute-pro-app.firebaseapp.com',
    projectId: 'kiute-pro-app',
    storageBucket: 'kiute-pro-app.appspot.com',
    messagingSenderId: '998907883237',
    appId: '1:998907883237:web:166a5f5cf5318d485d2e0c',
    measurementId: 'G-GFJ7ZS9SDS',
} as const;

const analytics = ((): firebase.analytics.Analytics => {
    try {
        if (IS_PRODUCTION && IS_MASTER) {
            firebase.initializeApp(FIREBASE_CONFIG);
            return firebase.analytics();
        }
    } catch (e) {
        console.warn('could not initialize firebase:', e);
    }
    // mock firebase analytics object used on staging and dev envs
    return {
        logEvent: (...args: Parameters<typeof analytics.logEvent>) =>
            // eslint-disable-next-line
            console.log('%c🔥 firebase event:', 'color: darkOrange;', ...args),
    } as firebase.analytics.Analytics;
})();

const logs = {
    // auth
    login: (): void => analytics?.logEvent('app_login'),
    logout: (): void => analytics?.logEvent('app_logout'),

    // agenda cell click -> forms
    cellOpenCreateBooking: (): void =>
        analytics?.logEvent('agenda_addEventView_openCreateBooking'),
    cellOpenCreateUnavailability: (): void =>
        analytics?.logEvent('agenda_addEventView_openCreateUnavailability'),
    cellOpenCreatePromotion: (): void =>
        analytics?.logEvent('agenda_addEventView_openCreatePromotion'),

    // agenda plus button -> forms
    buttonOpenCreateBooking: (): void =>
        analytics?.logEvent('agenda_addEventView_plusButton_openCreateBooking'),
    buttonOpenCreateUnavailability: (): void =>
        analytics?.logEvent(
            'agenda_addEventView_plusButton_openCreateUnavailability',
        ),
    buttonOpenCreatePromotion: (): void =>
        analytics?.logEvent(
            'agenda_addEventView_plusButton_openCreatePromotion',
        ),

    // bookings
    addCustomer: (): void =>
        analytics?.logEvent('agenda_createBooking_addCustomer'),
    addComment: (): void =>
        analytics?.logEvent('agenda_bookingView_addComment'),
    saveBooking: (): void =>
        analytics?.logEvent('agenda_createBookingView_saveBooking'),
    deleteBooking: (): void =>
        analytics?.logEvent('agenda_bookingView_deleteBooking'),

    // unavailability
    saveUnavailability: (): void =>
        analytics?.logEvent(
            'agenda_createUnavailabilityView_saveUnavailability',
        ),
    deleteUnavailability: (): void =>
        analytics?.logEvent('agenda_unavailabilityView_deleteUnavailability'),

    // agenda
    agendaRefresh: (): void => analytics?.logEvent('agenda_refresh'),
    selectSeveralResources: (): void =>
        analytics?.logEvent('agenda_resourcesView_selectSeveralResources'),
    howManyResourceSelected: (count: number): void =>
        analytics?.logEvent('agenda_resourcesView_howManyResourcesSelected', {
            [count]: count,
        }),

    // settings
    helpCenter: (): void => analytics?.logEvent('help_center'),
};

export default logs;
